/* 100X Equine nav behaviors — ported from gutx-nav.jsx (React) to vanilla JS.
   Mobile drawer toggle + body scroll lock, Escape to close, and scroll-to-grey
   via data-navscrolled on <html> (shared CSS handles the color). */
(function () {
  var burger = document.querySelector('[data-gxnav-burger]');
  var drawer = document.querySelector('[data-gxnav-drawer]');
  var scrim = document.querySelector('[data-gxnav-scrim]');

  function setMenu(open) {
    if (drawer) {
      drawer.classList.toggle('open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    if (scrim) scrim.classList.toggle('open', open);
    document.body.classList.toggle('m-locked', open);
    if (burger) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
  }

  if (burger) {
    burger.addEventListener('click', function () {
      setMenu(!(drawer && drawer.classList.contains('open')));
    });
  }
  if (scrim) scrim.addEventListener('click', function () { setMenu(false); });

  document.querySelectorAll('[data-gxnav-close], .m-drawer nav a, .m-drawer-cta a').forEach(function (el) {
    el.addEventListener('click', function () { setMenu(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setMenu(false);
  });

  function onScroll() {
    document.documentElement.setAttribute('data-navscrolled', window.scrollY > 8 ? 'true' : 'false');
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
